import { render, staticRenderFns } from "./QuoteEmailModal.vue?vue&type=template&id=489b70ea&scoped=true"
import script from "./QuoteEmailModal.vue?vue&type=script&lang=js"
export * from "./QuoteEmailModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteEmailModal.vue?vue&type=style&index=0&id=489b70ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b70ea",
  null
  
)

export default component.exports